import {
  CLEAR_SEARCH_HISTORY,
  SET_CURRENT_QUESTION,
  SET_NEW_QUESTION_AND_ANSWERS,
  SET_OPEN_HELP_TOPICS_MODAL,
} from '../actions/HelpTopicsActions';

const initialState = {
  isOpen: false,
  currentQuestion: null,
  questionsAndAnswers: [],
};

const helpTopicsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_OPEN_HELP_TOPICS_MODAL:
      return {
        ...state,
        isOpen: action.isOpen,
      };

    case SET_CURRENT_QUESTION:
      return {
        ...state,
        currentQuestion: state.questionsAndAnswers.find((item) => item.id === action.id) ?? null,
      };

    case CLEAR_SEARCH_HISTORY:
      return {
        ...state,
        questionsAndAnswers: [],
      };

    case SET_NEW_QUESTION_AND_ANSWERS:
      return {
        ...state,
        questionsAndAnswers: [...action.answer, ...state.questionsAndAnswers],
      };

    default:
      return state;
  }
};

export default helpTopicsReducer;
